angular.module('impactx.basket').controller('PriceRuleDialogCtrl',  [
    '$scope',
    'dataGen',
    '$context',
    '$redirect',
    'ToolbarService',
    'BackService',
    'ToastService',
    'TranslationService',
    PriceRuleDialogCtrl]);

function PriceRuleDialogCtrl($scope, dataGen, $context, $redirect, ToolbarService, BackService, ToastService, TranslationService) {
    ctrl = this;
    ctrl.parameters = $redirect.getLastParameters();
    $scope.priceRuleLabel = {};

    $scope.data = {};
    $scope.data.priceRule = {};
    $scope.data.priceRule.offset = {};
    $scope.data.priceRule.factor = {};
    $scope.data.priceRule.currency = {};
    $scope.data.priceRule.currency.selected = {id: 0}

    if(!ctrl.parameters || !Array.isArray(ctrl.parameters) || ctrl.parameters.length === 0) {
        $redirect.redirectTo(null, "productchangelist");
    }
    else {
        dataGen.getData($scope, {ids: ctrl.parameters}, '/product/pricerules/view').then(function () {
            if(!impactX.isDefined($scope, "data.priceRule.currency.selected"))
                $scope.data.priceRule.currency.selected = $scope.data.priceRule.currency.entries[0];
            initWatch();
            defineButtons();
        }, function () {
            BackService.back();
        });
    }

    ctrl.save = function () {
        return dataGen.postAsForm({}, {pricerules: $scope.data}, "/product/pricerules/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    }

    function updateProductPriceRules(rules, matchCode) {
        for (var key in rules) {
            $scope.priceRuleLabel[key] = rules[key]? (matchCode + ' = ' + rules[key]) : "";
        }
    }

    function initWatch() {
        $scope.$watch("data.priceRule.targetPopup.selected", function (newVal, oldVal) {
            if(newVal && newVal != oldVal)
            {
                dataGen.getData({}, {ids: ctrl.parameters, matchcode: newVal.id}, '/product/pricerules/view/productrules').then(function (data) {
                    if(impactX.isDefined(data, 'data.rules'))
                    {
                        updateProductPriceRules(data.data.rules, newVal.id);
                    }
                });
            }
        })

    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}